import React, { lazy } from 'react';
import { Link } from 'react-router-dom';
import { ArrowRightIcon, CalendarIcon, MapPinIcon, StarIcon } from 'lucide-react';
import { WhatsAppLogo } from './icons/WhatsAppLogo';
import { businessInfo, openingHours, googleReviews } from '../data/businessInfo';
export const CTASection = () => {
  return <section id="contact" className="py-16 bg-[#0a0a0a] relative border-t border-[#222]" data-id="element-106" data-mp="2hfuwwq4x8uhx">
      <div className="max-w-6xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-107" data-mp="2mcv0mueatl5v">
        <div className="flex flex-col lg:flex-row gap-6" data-id="element-108" data-mp="2qf9nrqp0372y">
          {/* Left side - CTA content */}
          <div className="w-full lg:w-1/2" data-id="element-109" data-mp="2v6hycq22gyhp">
            <div className="bg-[#0f0f0f] p-6 md:p-8 border border-[#222222] text-center lg:text-left relative h-full" data-id="element-110" data-mp="2v6rocdn435ne">
              <h2 className="text-2xl md:text-3xl font-bold text-white mb-4" data-id="element-111" data-mp="307fbgo87z2cc">
                Klaar voor een{' '}
                <span className="text-[#D6281F]" data-id="element-112" data-mp="352kzbsl6mr32">unieke look</span> voor jouw
                auto?
              </h2>
              <p className="text-[#CCCCCC] mb-5 text-base" data-id="element-113" data-mp="215yqatkm9njx">
                Laat je auto transformeren door de experts van BKCustoms. Maak
                een afspraak of krijg advies van onze specialisten.
              </p>
              {/* Social proof — 5,0 uit 72 Google reviews */}
              <a href={businessInfo.reviewsUrl} target="_blank" rel="noopener noreferrer" className="inline-flex items-center gap-2 mb-6 text-sm text-white/80 hover:text-white transition-colors duration-300" data-id="element-114" data-mp="1n6gw1yojxi36">
                <span className="flex" data-id="element-115" data-mp="2ezzg2xtlc085">
                  {[...Array(5)].map((_, i) => <StarIcon key={i} size={14} className="text-[#FFD700] fill-[#FFD700]" data-id="element-116" data-mp="2a4twi5nnuxn8" data-mpi={i} />)}
                </span>
                <span data-id="element-117" data-mp="2xwr5lozq7bkn">
                  <span className="text-white font-semibold" data-id="element-118" data-mp="2xw8yfxbizcxy">
                    {googleReviews.ratingDisplay}
                  </span>{' '}
                  uit {googleReviews.count} Google reviews
                </span>
              </a>
              {/* Conversion Buttons */}
              <div className="flex flex-col gap-3 mb-6" data-id="element-119" data-mp="m9f6kbbxmtcw">
                {/* Afspraak maken button */}
                <Link to="/afspraak-maken" className="block bg-[#D6281F] hover:bg-[#C02218] px-4 py-3 group" data-id="element-120" data-mp="r7qicrlsfdxr">
                  <div className="flex items-center justify-center lg:justify-start" data-id="element-121" data-mp="dak49ac0e3ev">
                    <CalendarIcon size={18} className="mr-2 text-white" data-id="element-122" data-mp="i8vevna4ohy5" />
                    <span className="text-white font-medium text-sm uppercase" data-id="element-123" data-mp="3bl46g5b7g3h">
                      Afspraak maken
                    </span>
                  </div>
                </Link>
                {/* Advies krijgen button */}
                <Link to="/contact" className="block bg-[#1a1a1a] hover:bg-[#222] border border-[#333] px-4 py-3 transition-colors duration-300 group" data-id="element-124" data-mp="1xm7vzfh935ps">
                  <div className="flex items-center justify-center lg:justify-start" data-id="element-125" data-mp="3n33hpe5gzrj3">
                    <span className="text-white font-medium text-sm uppercase" data-id="element-126" data-mp="3i4a3fjiczwhv">
                      Vraag ons advies
                    </span>
                  </div>
                </Link>
                {/* WhatsApp button */}
                <a href="https://wa.me/31627888306" target="_blank" rel="noopener noreferrer" className="block bg-[#1a1a1a] hover:bg-[#222] border border-[#333] px-4 py-3 transition-colors duration-300 group" data-id="element-127" data-mp="9q9ucm6gt99v">
                  <div className="flex items-center justify-center lg:justify-start" data-id="element-128" data-mp="epw9j15uszlb">
                    <WhatsAppLogo size={18} className="mr-2 text-[#25D366]" data-id="element-129" data-mp="2lg2r5gfaaugh" />
                    <span className="text-white font-medium text-sm uppercase" data-id="element-130" data-mp="2li6rjodz5bc0">
                      WhatsApp
                    </span>
                  </div>
                </a>
              </div>
              {/* Address info */}
              <div className="flex items-start border-t border-[#222] pt-4" data-id="element-131" data-mp="2mwzqywvg19ks">
                <MapPinIcon size={20} className="flex-shrink-0 text-[#D6281F] mr-2 mt-1" data-id="element-132" data-mp="2mz2sad21qp4t" />
                <div data-id="element-133" data-mp="2wvp7al7oylyx">
                  <h3 className="text-white font-medium text-base mb-1" data-id="element-134" data-mp="2wuxdnfxnmyba">
                    Bezoek onze werkplaats
                  </h3>
                  <p className="text-white/70 text-sm" data-id="element-135" data-mp="246rs4qys15ae">
                    Microfoonstraat 36
                    <br data-id="element-136" data-mp="295uyceqhthjy" />
                    1322 BN Almere
                    <br data-id="element-137" data-mp="294a46q83c0mm" />
                    {openingHours.short}
                  </p>
                </div>
              </div>
            </div>
          </div>
          {/* Right side - Location image */}
          <div className="w-full lg:w-1/2" data-id="element-138" data-mp="1ggny9bbe4jwl">
            <div className="h-full border border-[#222]" data-id="element-139" data-mp="1lg0om61h093x">
              <div className="relative h-full" data-id="element-140" data-mp="1leftofb8uo5j">
                {/* Image */}
                <img src="https://uploadthingy.s3.us-west-1.amazonaws.com/8EBZJkJmW22tzM2DKUohP4/IMG_3319-scaled-1.jpg" alt="BKCustoms werkplaats ingang" className="w-full h-full object-cover" loading="lazy" decoding="async" data-id="element-141" data-mp="2juua3a1pgs7" />
                {/* Overlay */}
                <div className="absolute inset-0 bg-gradient-to-t from-black to-transparent opacity-70" data-id="element-142" data-mp="3fs7m18fldbaw"></div>
                {/* Content overlay */}
                <div className="absolute bottom-0 left-0 right-0 p-6" data-id="element-143" data-mp="3azo8gbgwmg63">
                  <h3 className="text-xl font-bold text-white mb-2" data-id="element-144" data-mp="370feb5hycga0">
                    Kom langs voor een persoonlijk advies
                  </h3>
                  <p className="text-white/80 mb-3 text-sm" data-id="element-145" data-mp="31ygc3yxy7pen">
                    Ontdek wat wij voor jouw auto kunnen betekenen in onze
                    professionele werkplaats.
                  </p>
                  <a href="https://maps.google.com/?q=Microfoonstraat+36+1322+BN+Almere" target="_blank" rel="noopener noreferrer" className="inline-flex items-center bg-[#1a1a1a] hover:bg-[#222] border border-[#333] px-3 py-1.5 text-white text-xs transition-colors duration-300" data-id="element-146" data-mp="2iehg5xhw40ax">
                    <MapPinIcon size={14} className="mr-1.5" data-id="element-147" data-mp="2dhh9plh4ovja" />
                    Route plannen
                  </a>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>;
};